import React from "react"
import AccountFeatureSettings from "../../../account/settings/AccountFeatureSettings"
import AccountMobileFeatureSettings from "../../../account/settings/AccountMobileFeatureSettings"
import SettingsCard from "../../../common/SettingsCard"
import strings from "../../../../localization/strings"
import { IAccountDocument } from "../../../../models"

interface IProps {
    account: IAccountDocument
    readOnly?: boolean
    updateLoadedAccount(account: IAccountDocument): Promise<IAccountDocument>
}
interface IState {
    expanded: string
}

export default class AccountManagerClientTabFeatures extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expanded: ""
        }

    }

    onExpandClick(type) {
        this.setState({ expanded: this.state.expanded === type ? "" : type })
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <SettingsCard expanded={"features" === this.state.expanded} cardLabel={strings.Features} handleExpandChange={() => this.onExpandClick("features")}>
                    <AccountFeatureSettings
                        account={this.props.account}
                        readOnly={this.props.readOnly}
                        accountManager
                        updateLoadedAccount={this.props.updateLoadedAccount}
                    />
                </SettingsCard>
                <SettingsCard expanded={"mobile" === this.state.expanded} cardLabel={strings.Mobile} handleExpandChange={() => this.onExpandClick("mobile")}>
                    <AccountMobileFeatureSettings
                        account={this.props.account}
                        readOnly={this.props.readOnly}
                        accountManager
                        updateLoadedAccount={this.props.updateLoadedAccount}
                    />
                </SettingsCard>
            </div>
        )
    }
}
